<template>
  <div class="d-flex justify-content-end mt-3">
    <select class="form-select" style="width:80px;margin-right: 30px" @change="rowsFun" v-model="rows">
      <option value="10">10</option>
      <option value="20">20</option>
      <option value="50">50</option>
    </select>
    <div class="pagination-wrap hstack gap-2">
      <div class="page-item pagination-next" v-if="selectPage>5" @click="selectPageFun(1)">
        {{$t('page1')}}
      </div>
      <div class="page-item pagination-prev disabled" href="#" v-if="selectPage != 1" @click="selectPageFun(selectPage,'-')">
        {{$t('previous')}}
      </div>
      <ul class="pagination listjs-pagination mb-0">
        <li class="disabled" v-if="selectPage>5">
          <div class="page" href="#">...</div>
        </li>

          <li v-for="i in pagingTotality"
              :key="i"  @click="selectPageFun(i)"
              :class="{active: i == selectPage}"
              v-show="selectPage+4>=i&&selectPage-i<=4">
            <div class="page" href="#" >{{ i }}</div>
          </li>
        <li class="disabled" v-if="pagingTotality-selectPage>4">
          <div class="page" href="#" >...</div>
        </li>
      </ul>
      <div class="page-item pagination-next" href="#" @click="selectPageFun(selectPage,'+')" v-if="selectPage < pagingTotality">
        {{$t('next')}}
      </div>
      <div class="page-item pagination-next" v-if="pagingTotality-selectPage>4" @click="selectPageFun(pagingTotality)">
        {{$t('page2')}}
      </div>
    </div>
  </div>

</template>
<script>
    export default {
        data() {
            return {
            };
        },
        props:{
            selectPage:{
                type: Number,
                default: 1
            },
            pagingTotality:{
                type: Number,
                default: 10
            },
        },
        mounted() {
            console.log(this.selectPage)
        },

        methods: {
            selectPageFun(page,type){
                this.$emit('previousPageFun',page,type)
            },
        },
    };
</script>
